import React from 'react';
import { Form } from 'react-bootstrap';

interface CheckboxProps {
  name: string;
  label: string;
  checked: boolean;
  style?: React.CSSProperties;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  name,
  label,
  checked,
  style,
  onChange,
  ...props
}) => (
  <Form.Check
    type="checkbox"
    id={name}
    name={name}
    label={label}
    checked={checked}
    onChange={onChange}
    style={style || { fontSize: '1.5rem' }}
    {...props}
  />
);

export default Checkbox;
